import type { Translations } from '../types';

export const es: Translations = {
  // Header
  signIn: 'Iniciar Sesión',
  getStarted: 'Comenzar',

  // Hero
  heroTitle1: 'Descubre',
  heroTitle2: 'tu comunidad.',
  heroDescription:
    'Descubre negocios auténticos, reserva ofertas de proveedores de tu comunidad y conecta con personas en las que confías — en cualquier parte del mundo.',
  detected: 'Detectado:',
  detectingLocation: 'Detectando ubicación…',
  locationUnavailable: 'Ubicación no disponible',
  joinCommunity: 'Únete a Tu Comunidad',
  learnMore: 'Saber Más',

  // Community Selection
  selectCommunity: 'Selecciona tu comunidad',
  selectCommunityDesc: 'Únete a la comunidad que se siente como en casa',
  exploreMore: 'Explorar Más Comunidades',

  // Status Badges
  active: 'Activo',
  incubating: 'Incubando',

  // Community Names (localizable)
  everywhereElse: 'Resto del Mundo',

  // Features
  howConnect: '¿Cómo te conectas?',
  howConnectDesc:
    'Quul te ayuda a descubrir, reservar y compartir lo que importa en tu comunidad.',
  discover: 'Descubrir',
  discoverDesc:
    'Encuentra negocios auténticos, servicios y eventos recomendados por personas en las que confías.',
  review: 'Reseñar',
  reviewDesc:
    'Comparte tus experiencias con calificaciones multidimensionales y reseñas detalladas.',
  connect: 'Conectar',
  connectDesc:
    'Chatea con miembros de la comunidad, dueños de negocios y proveedores de servicios.',
  marketplace: 'Reservar',
  marketplaceDesc:
    'Reserva ofertas de proveedores de tu comunidad. Pago seguro vía Stripe, con política clara de cancelación y reembolso.',

  // CTA
  ctaTitle: '¿Listo para unirte a tu comunidad?',
  ctaDesc:
    'Regístrate ahora y descubre lo que tu comunidad ha estado compartiendo.',
  getStartedFree: 'Comenzar Gratis',

  // Footer
  terms: 'Términos',
  privacy: 'Privacidad',
  childSafety: 'Seguridad Infantil',
  reportNotice: 'Reportar o notificar infracción',
  contact: 'Contacto',
  mayilabsLine: 'Quul es un producto de MayiLabs LLC · Shakopee, Minnesota, EE. UU.',

  // App Store
  comingSoon: 'Próximamente',
  appStore: 'App Store',
  googlePlay: 'Google Play',
  getOnGooglePlay: 'Disponible en',
  getOnAppStore: 'Descárgalo en la',
  comingToAppStore: 'Próximamente en',
  manos: {
    ribbonText: 'Antes de abrir nuestro mercado, abrimos un Centro de Crisis para Venezuela.',
    ribbonCta: 'Ver',
    ribbonDismiss: 'Cerrar aviso',
    navItem: 'Venezuela',
    bandHeadline: 'Centro de Crisis — Venezuela',
    bandSubtext: 'Organizaciones verificadas, canales oficiales para localizar familiares e información confiable.',
    ctaHelp: 'Cómo ayudar',
    ctaFindOffer: 'Buscar u ofrecer ayuda',
    ctaLocate: 'Localizar a un familiar',
    modalTitle: 'Antes de abrir nuestro mercado, abrimos un Centro de Crisis',
    modalBody: 'Reunimos organizaciones verificadas, canales oficiales para localizar familiares e información confiable para la emergencia en Venezuela.',
    modalPrimary: 'Ir al Centro de Crisis',
    modalDismiss: 'Ahora no',
    modalClose: 'Cerrar',
  },
};
